export const RADIO = '/radio'
export const PODCASTS = '/podcasts'
export const MUSIC = '/music'
export const BOOKS = '/books'
export const LOGIN = '/login'
export const LOADING = '/'
export const HOME = '/home'
